import OwlCarousel from 'react-owl-carousel';
import { Property } from '../../../types/property';
import { PropertyCarouselProps } from './types';
import './styles.scss';
import PropertyPictureSlider from './PropertyPIctureSlider/PropertyPictureSlider';

const responsivenessConfig = {
  320: {
    items: 1,
    stagePadding: 0
  },
  577: {
    items: 1,
    stagePadding: 100
  },
  800: {
    items: 1,
    stagePadding: 200
  },
  1000: {
    items: 2,
    stagePadding: 120
  },
  1200: {
    items: 2,
    stagePadding: 150
  },
  1400: {
    items: 2,
    stagePadding: 150
  },
  1600: {
    items: 3,
    stagePadding: 100
  },
  1750: {
    items: 3,
    stagePadding: 150
  }
};

const PropertyCarousel = (props: PropertyCarouselProps) => {
  const { properties, showNav = true } = props;

  return (
    <div className="property-carousel-slider-section">
      <OwlCarousel
        className="owl-theme property-slider"
        stagePadding={16}
        loop={false}
        nav={showNav}
        navClass={['arrowLeft', 'arrowRight']}
        dots={true}
        lazyLoad={true}
        margin={15}
        responsive={responsivenessConfig}
      >
        {!!properties && properties.map((property: Property, key: number) => <PropertyPictureSlider key={key} ownKey={key} property={property} />)}
      </OwlCarousel>
    </div>
  );
};

export default PropertyCarousel;
